export default __webpack_public_path__ + "static/media/card2-1.5ee4ff2b.svg";